import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import reactStringReplace from 'react-string-replace';
import {
    Text,
    Alert as ConstAlert,
} from '@zillow/constellation';

import { DELIMITER } from 'app/shared/constants/AnalyticsDelimiterConstants';

import {
    GA_EVENTS,
    GA_PREFIX,
} from 'app/shared/constants/AnalyticsListingModuleConstants';

import { LISTING_SUMMARY_DISPLAY_STATUS } from 'app/shared/constants/ListingSummaryConstants';

import analyticsUtils from 'app/client/utils/analyticsUtils';
import stringHelper from 'app/shared/utils/stringHelper';

import { StyledAnchor } from './StyledComponents';

const Alert = (props) => {
    const dispatch = useDispatch();

    const {
        status,
        listingSummary,
    } = props;

    const {
        syndication: {
            universal,
        },
    } = listingSummary;

    const appearance = status === LISTING_SUMMARY_DISPLAY_STATUS.DECLINED ? 'error' : 'warning';

    const { message, replaceUrl, replaceText } = universal;

    const handleLearnMoreClick = (event) => {
        const { LEARN_MORE_SYNDICATION_CLICK } = GA_EVENTS;
        const { LEARN_MORE_SYNDICATION } = GA_PREFIX;

        // double check the replaced text
        // might not always be Learn more
        if (event.target.innerText === 'Learn more') {
            dispatch(analyticsUtils.track.GAEventV2({
                ...LEARN_MORE_SYNDICATION_CLICK,
                action: `${LEARN_MORE_SYNDICATION}${DELIMITER}${stringHelper.startCaseRemoveSpace(status)}`,
            }));
        }
    };

    const renderedMessage = reactStringReplace(message, replaceText, () => (
        <Text
            fontType="body"
        >
            <StyledAnchor
                href={replaceUrl}
                target="_blank"
                onClick={handleLearnMoreClick}
            >
                {replaceText}
            </StyledAnchor>
        </Text>
    ));

    return (
        <ConstAlert
            className="Alert"
            appearance={appearance}
            body={renderedMessage}
        />
    );
};

Alert.propTypes = {
    status: PropTypes.string.isRequired,
    listingSummary: PropTypes.object.isRequired,
};

Alert.defaultProps = {};

export default Alert;
